import axios from "axios";
import { baseUrls, getEflowBaseUrl } from "./api.types";
import { errorInterceptor, requestInterceptor, successInterceptor } from "./interceptors";
const axiosRequestConfig = {
    baseURL: baseUrls.caasV1ApiDev.url,
    headers: {
        // "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json"
    },
    responseType: "json"
};
const entitlementsRequestConfig = {
    baseURL: baseUrls.entitlementsV1Api.url,
    headers: {
        "Content-Type": "application/json"
    },
    responseType: "json"
};
const caasClientRequestConfig = {
    baseURL: baseUrls.caasClientV1Api.url,
    headers: {
        "Content-Type": "application/json"
    },
    responseType: "json"
};
const appConfigRequest = {
    baseURL: "",
    headers: {
        "Content-Type": "application/json"
    },
    responseType: "json"
};
const eflowRequestConfig = {
    baseURL: getEflowBaseUrl(),
    headers: {
        "Content-Type": "application/json"
    },
    responseType: "json"
};
const baasRequestConfig = {
    baseURL: baseUrls.baasV2ApiProd.url,
    headers: {
        "Content-Type": "application/json"
    },
    responseType: "json"
};
const assetsV2RequestConfig = {
    baseURL: baseUrls.assetsV2Api.url,
    headers: {
        "Content-Type": "application/json"
    },
    responseType: "json"
};
const api = axios.create(axiosRequestConfig);
const appConfigApi = axios.create(appConfigRequest);
const entitlementsApi = axios.create(entitlementsRequestConfig);
const caasClientLogsApi = axios.create(caasClientRequestConfig);
const eflowApi = axios.create(eflowRequestConfig);
const baasApi = axios.create(baasRequestConfig);
const assetsV2Api = axios.create(assetsV2RequestConfig);
api.interceptors.request.use(requestInterceptor);
api.interceptors.response.use(successInterceptor, errorInterceptor);
entitlementsApi.interceptors.request.use(requestInterceptor);
entitlementsApi.interceptors.response.use(successInterceptor, errorInterceptor);
caasClientLogsApi.interceptors.request.use(requestInterceptor);
caasClientLogsApi.interceptors.response.use(successInterceptor, errorInterceptor);
appConfigApi.interceptors.request.use(requestInterceptor);
appConfigApi.interceptors.response.use(successInterceptor, errorInterceptor);
eflowApi.interceptors.request.use(requestInterceptor);
eflowApi.interceptors.response.use(successInterceptor, errorInterceptor);
baasApi.interceptors.request.use(requestInterceptor);
baasApi.interceptors.response.use(successInterceptor, errorInterceptor);
assetsV2Api.interceptors.request.use(requestInterceptor);
assetsV2Api.interceptors.response.use(successInterceptor, errorInterceptor);
export { api, appConfigApi, assetsV2Api, baasApi, caasClientLogsApi, eflowApi, entitlementsApi };
